import {
  Component,
  inject,
} from '@angular/core';
import {
  AsyncPipe,
  ViewportScroller,
} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import {orderBy} from 'lodash';
import {map} from 'rxjs';
import {ContentSectionsComponent} from '../../components/content-sections/content-sections.component';
import {HeaderComponent} from '../../components/header/header.component';
import {BackButtonComponent} from '../../components/back-button/back-button.component';
import {PageTitleComponent} from '../../components/page-title/page-title.component';
import {CommonSpacerComponent} from '../../components/common-spacer/common-spacer.component';
import {AppState} from '../../store/store';
import {selectDocumentsList} from '../../store/portal/portal.selectors';
import {DocumentCardComponent} from '../../components/documnet-card/document-card.component';
import {downloadDocument} from '../../store/portal/portal.actions';
import {SortDirection} from '../../enums/sort-direction';
import {FooterInfoComponent} from '../../components/footer-info/footer-info.component';
import {selectIsPreviewMode} from '../../store/shared-link/shared-link.selectors';

@Component({
  selector: 'app-docs',
  imports: [ContentSectionsComponent, HeaderComponent, TranslatePipe, BackButtonComponent, CommonSpacerComponent,
    PageTitleComponent, CommonSpacerComponent, DocumentCardComponent, FooterInfoComponent, AsyncPipe],
  templateUrl: './docs.component.html',
  styleUrl: './docs.component.scss',
})
export class DocsComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private viewportScroller: ViewportScroller = inject(ViewportScroller);

  public additionalDocumentsList$ = this.store.select(selectDocumentsList).pipe(
    map(documents => orderBy(documents, ['uploadedAt'], SortDirection.DESC)),
  );

  public previewMode$ = this.store.select(selectIsPreviewMode);

  constructor() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  downloadDocument(documentId: string): void {
    this.store.dispatch(downloadDocument({documentId}));
  }

}
